export default "__VITE_ASSET___q8WtrIS__"